export const FETCH_SECTORS_REQUEST = 'FETCH_SECTORS_REQUEST';
export const FETCH_SECTORS_SUCCESS = 'FETCH_SECTORS_SUCCESS';
export const FETCH_SECTORS_FAILURE = 'FETCH_SECTORS_FAILURE';

export const FETCH_SECTORS_RELEASE_REQUEST = 'FETCH_SECTORS_RELEASE_REQUEST';
export const FETCH_SECTORS_RELEASE_SUCCESS = 'FETCH_SECTORS_RELEASE_SUCCESS';
export const FETCH_SECTORS_RELEASE_FAILURE = 'FETCH_SECTORS_RELEASE_FAILURE';

export const FETCH_SECTOR_REQUEST = 'FETCH_SECTOR_REQUEST';
export const FETCH_SECTOR_SUCCESS = 'FETCH_SECTOR_SUCCESS';
export const FETCH_SECTOR_FAILURE = 'FETCH_SECTOR_FAILURE';

export const UPDATE_SECTORS_REQUEST = 'UPDATE_SECTORS_REQUEST';
export const UPDATE_SECTORS_SUCCESS = 'UPDATE_SECTORS_SUCCESS';
export const UPDATE_SECTORS_FAILURE = 'UPDATE_SECTORS_FAILURE';

export const DELETE_SECTORS_REQUEST = 'DELETE_SECTORS_REQUEST';
export const DELETE_SECTORS_SUCCESS = 'DELETE_SECTORS_SUCCESS';
export const DELETE_SECTORS_FAILURE = 'DELETE_SECTORS_FAILURE';

export const OPEN_EDIT_PAGE_SECTOR = 'OPEN_EDIT_PAGE_SECTOR';
export const OPEN_EDIT_PAGE_SECTOR_SUCCESS = 'OPEN_EDIT_PAGE_SECTOR_SUCCESS';

export const CLEAR_SECTOR_ERRORS = 'CLEAR_SECTOR_ERRORS';
export const CLEAR_SECTOR_SUCCESS = 'CLEAR_SECTOR_SUCCESS';